import { useEffect, useState } from "react";
import { Role, Session } from "./types";

function isInSession(startDateTime?: string, exact?: boolean) {
  const scalar = exact
    ? 0
    // 10 minutes before session starts
    : (10 * 60000);
  return startDateTime
    ? new Date(startDateTime).getTime() - scalar < Date.now()
    : false;
}

export function isSessionEnded(session?: Session) {
  return session?.startDateTime
    ? new Date(session.startDateTime).getTime() + session.duration * 60000 < Date.now()
    : false;
}

export function useIsInSession(session?: Session, exact?: boolean) {
  const [inSession, setInSession] = useState<boolean>(
    isInSession(session?.startDateTime, exact)
  );

  useEffect(() => {
    const isIn = () => setInSession(() => {
      const inSession = isInSession(session?.startDateTime, exact)
      console.debug('is in session?', session?.guid, inSession)
      return inSession
    })
    isIn()

    const handle = window.setInterval(isIn, 5000)

    return () => window.clearInterval(handle)
  }, [
    exact,
    session?.guid,
    session?.startDateTime
  ])

  return inSession
}

export function isUnavailable(session?: Session, role?: Role) {
  return session?.unavailable || isSessionEnded(session) || (
    role === 'member' && !session?.seats && !session?.booked
  )
}